

























import { ShowManagementService as showApi } from "@/common/api";
import QErrors from "@/common/qErrors.vue";
import { debounce } from "lodash";
import { Component, PropSync } from "vue-property-decorator";
import { Vue } from "vue-property-decorator";
import vSelect from "vue-select";

@Component({
  name: "qSelectShows",
  components: { QErrors, vSelect },
})
export default class qSelectShows extends Vue {
  get hasNextPage() {
    return this.paginator.currentPage < this.paginator.lastPages;
  }
  @PropSync("itemId", {
    default: 0,
  })
  public itemIdSync;

  @PropSync("selectedItem", {
    default: () => {
      return {};
    },
  })
  public selectedItemSync;

  public limit = 30;
  public observer = null;
  public items = [];
  public paginator: any = {
    currentPage: 1,
    lastPages: 1,
    perPage: 30,
    total: 0,
  };
  public filter = {
    perPage: 30,
    page: 1,
    disabledLoadinng: true,
    title: "",
  };
  public item = null;

  public fetchOption = debounce((search) => {
    this.filter.page = 1;
    this.filter.title = search;
    this.paginator.currentPage = 1;
    this.getItems({ ...this.filter, title: search });
  }, 500);

  public mounted() {
    this.observer = new IntersectionObserver(this.infiniteScroll as any);
  }

  public async onOpen() {
    this.filter.page = 1;
    this.filter.title = "";
    this.items = [];
    await this.getItems({ ...this.filter });
    if (this.$refs.load) {
      this.observer.observe(this.$refs.load);
    }
  }

  public onClose() {
    this.observer?.disconnect();
  }

  public async infiniteScroll([{ isIntersecting, target }]) {
    if (isIntersecting) {
      const ul = target.offsetParent;
      const scrollTop = target.offsetParent.scrollTop;
      this.paginator.currentPage += 1;
      this.filter.page = this.paginator.currentPage;
      await this.getItems({ ...this.filter }, this.items);
      ul.scrollTop = scrollTop;
    }
  }

  public async getItems(query = {}, items = []) {
    const result = await showApi.adminShowListForSelect(query);
    this.paginator = result.data.paginator;
    this.items = [...items, ...result.data.shows];
  }

  public selecteItem() {
    this.$emit("input", this.selectedItemSync);
  }
}
